/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_Feature_3Inputs */

const et_plan_best_feature_3 = /** @type {(inputs: Plan_Best_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking 10+ märksõna jaoks`)
};

const en_plan_best_feature_3 = /** @type {(inputs: Plan_Best_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking for 10+ keywords`)
};

/**
* | output |
* | --- |
* | "Ranking for 10+ keywords" |
*
* @param {Plan_Best_Feature_3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_feature_3 = /** @type {((inputs?: Plan_Best_Feature_3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_Feature_3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_feature_3(inputs)
	return en_plan_best_feature_3(inputs)
});